import { useState, useEffect } from 'react';
import Button from '../../../../app/components/Button';
import { usePageTitle } from '../../../../contexts/PageTitleContext';

const StatusBadge = ({ status }) => {
  return (
    <span className={`text-xs px-2 py-1 rounded-full ${
      status === 'SUCESSO' 
        ? 'bg-emerald-100 text-emerald-600' 
        : status === 'FALHA'
          ? 'bg-red-100 text-red-600'
          : 'bg-gray-100 text-gray-600'
    }`}>
      {status}
    </span>
  );
};

const ExecutionLogItem = ({ time, description, status }) => {
  return (
    <tr className="border-b border-gray-100">
      <td className="py-3 px-4 text-sm text-gray-700">{time}</td>
      <td className="py-3 px-4 text-sm text-gray-700">{description}</td>
      <td className="py-3 px-4">
        <StatusBadge status={status} />
      </td>
    </tr>
  );
};

const ExecutionHistory = () => {
  const { setTitle } = usePageTitle();
      
  useEffect(() => {
    setTitle('Detalhes da Automação');
  }, [setTitle]);

  const [logs, setLogs] = useState([]);
  const [isAutomationRunning, setIsAutomationRunning] = useState(true);

  useEffect(() => {
    setLogs([
      { time: '10:00:28', description: 'E-mail enviado com sucesso para celianny@odoscontabilidade.com.br.', status: 'SUCESSO' },
      { time: '09:38:22', description: 'E-mail enviado com sucesso para damirysdiniz@gmail.com.', status: 'SUCESSO' },
      { time: '09:37:44', description: 'E-mail enviado com sucesso para damirysdiniz@gmail.com.', status: 'SUCESSO' },
      { time: '09:37:02', description: 'E-mail enviado com sucesso para samara@odoscontabilidade.com.br.', status: 'SUCESSO' },
      { time: '09:36:12', description: 'E-mail enviado com sucesso para samara@odoscontabilidade.com.br.', status: 'SUCESSO' },
      { time: '09:35:41', description: 'E-mail enviado com sucesso para samara@odoscontabilidade.com.br.', status: 'SUCESSO' },
      { time: '09:34:31', description: 'Envio de e-mail já realizado recentemente para este card.', status: 'SUCESSO' },
      { time: '09:33:27', description: 'E-mail enviado com sucesso para samara@odoscontabilidade.com.br.', status: 'SUCESSO' },
      { time: '09:33:27', description: 'Envio de e-mail já realizado recentemente para este card.', status: 'SUCESSO' }
    ]);
  }, []);

  const handleStopAutomation = () => {
    setIsAutomationRunning(false);
    
    const newLog = {
      time: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
      description: 'Automação interrompida pelo usuário.',
      status: 'FALHA'
    };
    
    setLogs([newLog, ...logs]);
  };

  return (
    <div>
      <div className="mb-6 flex justify-between items-center">
        <h3 className="text-sm font-medium text-gray-700">Histórico de execução</h3>
        <Button 
          onClick={handleStopAutomation}
          disabled={!isAutomationRunning}
        >
          {isAutomationRunning ? 'Parar Automação' : 'Automação Parada'}
        </Button>
      </div>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                HORA (GMT-3)
              </th>
              <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                DESCRIÇÃO
              </th>
              <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                STATUS
              </th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log, index) => (
              <ExecutionLogItem
                key={index}
                time={log.time}
                description={log.description}
                status={log.status}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExecutionHistory;